import { z } from 'zod';

// Schemas (source of truth)
export const resourceCountByLocationSchema = z.object({
	totalCount: z.number(),
	floors: z.record(
		z.string(),
		z.object({
			floorTotal: z.number(),
			areas: z.record(z.string(), z.number()),
		})
	),
});

// Types (derived from schemas)
export type IResourceCountByLocation = z.infer<typeof resourceCountByLocationSchema>;
